import styled from 'styled-components';
import { gridSizes } from 'utils/style';

import FeedbackError from 'components/FeedbackError/container';

export default styled(FeedbackError)`
  animation: fadein 0.3s, stay 50s 0.3s, fadeout 0.3s 50.3s;
  transition-timing-function: cubic-bezier(0.25, 0.1, 0.25, 0.1);

  display: flex;
  align-items: center;
  padding: 0px ${gridSizes('M')};
  width: 100%;
  height: 0;
  overflow: hidden;
  flex-shrink: 0;

  background-color: #fc9403;
  color: #fff;
  a {
    color: #fff;
  }

  @keyframes fadein {
    from {
      height: 0;
      opacity: 0;
    }
    to {
      height: 55px;
      opacity: 1;
    }
  }

  @keyframes stay {
    from {
      height: 55px;
      opacity: 1;
    }
    to {
      height: 55px;
      opacity: 1;
    }
  }

  @keyframes fadeout {
    from {
      height: 55px;
    }
    to {
      height: 0;
    }
  }
`;
